'use client';

import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

export interface ContentSize {
  width: number;
  height: number;
}

interface SizeContextValue {
  size: ContentSize;
  setSize: (size: ContentSize) => void;
}

const SizeContext = createContext<SizeContextValue>({
  size: { width: 0, height: 0 },
  setSize: () => {},
});

export function SizeProvider({ children }: { children: ReactNode }) {
  const [size, setSize] = useState<ContentSize>({ width: 0, height: 0 });
  const value = useMemo(() => ({ size, setSize }), [size]);
  return <SizeContext.Provider value={value}>{children}</SizeContext.Provider>;
}

export function useContentSize(): ContentSize {
  return useContext(SizeContext).size;
}

export function useSetContentSize(): (size: ContentSize) => void {
  return useContext(SizeContext).setSize;
}
